export default __webpack_public_path__ + "static/media/hht1_ep08_book_wp_02.7aca7903.jpg";